export const replaceBulletListQuillElements = (htmlString) => {
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  const bulletItems = doc.querySelectorAll('li[data-list="bullet"]');

  bulletItems.forEach((li) => {
    const parentOl = li.closest('ol');
    if (!parentOl) { return; }

    const newUl = document.createElement('ul');
    parentOl.querySelectorAll('li[data-list="bullet"]').forEach((bulletLi) => {
      newUl.appendChild(bulletLi);
    });

    parentOl.parentNode.insertBefore(newUl, parentOl.nextSibling);
  });

  return doc.body.innerHTML;
};

export default replaceBulletListQuillElements;
